export default __webpack_public_path__ + "static/media/leader_notes_detailed.3b90cc11.pdf";